/** Orchestrates task list actions by delegating to sub-hooks for subtasks and editing. */
import { useState } from 'react';
import { useNewTaskAddedEffect } from '@/features/tasks/hooks/list/use-list-actions.helpers';
import { useTaskListAddHandlers } from '@/features/tasks/hooks/list/use-list-actions-add';
import { useTaskListActionGroups } from '@/features/tasks/hooks/list/use-list-actions-groups';

export function useTaskListActions({
  allTasks,
  user,
  addTask,
  updateTask,
  selectNewTask,
  editingTaskId,
  onStopEditing,
  deselectAllTasks,
  selectSingleTask,
  taskListRef,
  newTaskSessionRef,
  cancelNewTaskInputRef,
}) {
  const [newlyAddedTask, setNewlyAddedTask] = useState(null);

  useNewTaskAddedEffect({
    newlyAddedTask,
    setNewlyAddedTask,
    selectSingleTask,
    taskListRef,
    newTaskSessionRef,
    cancelNewTaskInputRef,
  });

  const { handleAddTask, handleTaskAdded } = useTaskListAddHandlers({
    user,
    addTask,
    selectNewTask,
    newTaskSessionRef,
    setNewlyAddedTask,
  });

  const actionGroups = useTaskListActionGroups({
    allTasks,
    user,
    updateTask,
    handleAddTask,
    deselectAllTasks,
    onStopEditing,
    editingTaskId,
    selectSingleTask,
    taskListRef,
  });

  return { handleAddTask, handleTaskAdded, ...actionGroups };
}
